import { authHeader } from "../../_helpers/auth-header";
import { appConfig, headerConfig } from "../../config";
import auth from "../auth";

export const announcementsService = {
  addAnnouncements,
  getAnnouncementsList,
  deleteAnnouncements,
  getAnnouncementsDetails,
  updateAnnouncements,
  get_SiteList
};

function refineHeader() {
  let token = auth.getToken();
  if (token != "") {
    headerConfig.headerDatas["Authorization"] = "Bearer " + token;
  }
}

function addAnnouncements(propsData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(propsData)
  };

  return fetch(`${appConfig.api.url}announcements/add`, requestOptions)
    .then(handleResponse)
    .then(announcements => {
      return announcements;
    });
}

function getAnnouncementsList(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}announcements/list`, requestOptions)
    .then(handleResponse)
    .then(announcements => {
      return announcements;
    });
}

function deleteAnnouncements(announcementsIdASParams) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(announcementsIdASParams)
  };

  return fetch(
    `${appConfig.api.url}announcements/delete/${announcementsIdASParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(announcements => {
      return announcements;
    });
}

function getAnnouncementsDetails(announcementsIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}announcements/detail/${announcementsIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(announcementsDetails => {
      return announcementsDetails;
    });
}

function updateAnnouncements(propsData) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(propsData)
  };

  return fetch(`${appConfig.api.url}announcements/edit`, requestOptions)
    .then(handleResponse)
    .then(updatedAnnouncements => {
      return updatedAnnouncements;
    });
}

function get_SiteList(page) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(page)
  };

  return fetch(`${appConfig.api.url}site/list`, requestOptions)
    .then(handleResponse)
    .then(sitelist => {
      return sitelist;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/announcementsService.js